import React from 'react';

import CheckboxAndRadioGroup from './common/CheckboxAndRadioGroup';

const RadioGroup = (props) => <CheckboxAndRadioGroup {...props} />; // eslint-disable-line

export default RadioGroup;
